// src/components/SlotMachine.js

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SlotColumn from '../slotColumn';
import Arrow from "../../images/Arrow.svg";
import Lever from "../../images/Lever.gif";
import LeverStart from "../../images/Lever_Start.png";
import Title3 from "../../images/Title3.svg";
import { Typography } from '@mui/material';
import useWindowSize from 'react-use/lib/useWindowSize'
import Confetti from 'react-confetti';
import 'animate.css';

import './SlotMachine.css';

const DownturnCause = ["Tech Crash", "Banking Crash", "Pandemic", "Animal Spirits", "Oil Shock", "Housing Crash", "Energy Price Crash", "War", "Stock Market Crash", "Population Decline"]
const Policy = ["Spending", "Direct Payments", "Unemployment Insurance", "Tax Cuts"]
const Implementation = ["Skill Mismatch", "Direct Payments", "Slow", "Targeted", "Mis-targeted", "Corruption", "Automatic", "Unproductive", "Too Much Saving", "Too Large"]


const getRandomDownturnCause = () => DownturnCause[Math.floor(Math.random() * DownturnCause.length)];
const getRandomPolicy = () => Policy[Math.floor(Math.random() * Policy.length)];
const getRandomImplementation = () => Implementation[Math.floor(Math.random() * Implementation.length)];
// const getRandomCombination = () => combinations[Math.floor(Math.random() * combinations.length)];

const SlotMachine = (props) => {
  const { question, nextQuestion, questionIndex, appState, updateAppState } = props;
  const [reels, setReels] = useState(appState.currentOptionsShowing);
  const [spinning, setSpinning] = useState(false);
  const [stoppingPhase, setStoppingPhase] = useState([false, false, false]);
  const [finished, setFinished] = useState(appState.finished);
  const [animation, setAnimation] = useState(false);
  const { width, height } = useWindowSize()

  const startSpinByButton = () => {
    setOnlyTextClass('animate__animated animate__fadeOutUp animate__slow')
    setAnimation(false)
    if(finished){
      setTimeout(() => {
        nextQuestion()
      }, 1700)
    }
    handleAnimation()
  }

  const restartGame = () => {
    window.location.reload()
  }

  useEffect(() => {
    if (spinning) {
      const newIntervals = reels.map((_, index) => {
        return setInterval(() => {
          setReels(prevReels => {
            const newReels = [...prevReels];
            newReels[index] = getRandomDownturnCause();
            return newReels;
          });
        }, 100);
      });

      // Stop each reel with delays
      setTimeout(() => {
        setReels(prevReels => {
          const newReels = [...prevReels];
          newReels[0] = question.combination[0];
          return newReels;
        });
        clearInterval(newIntervals[0]);
        setStoppingPhase(prev => {
          const newPhase = [...prev];
          newPhase[0] = true;
          return newPhase;
        });
      }, 1500); // Stop first reel after 1.5 seconds
      
      setTimeout(() => {
        setReels(prevReels => {
          const newReels = [...prevReels];
          newReels[1] = question.combination[1];
          return newReels;
        });
        clearInterval(newIntervals[1]);
        setStoppingPhase(prev => {
          const newPhase = [...prev];
          newPhase[1] = true;
          return newPhase;
        });
      }, 2500); // Stop second reel after an additional 1 second

      setTimeout(() => {
        setReels(prevReels => {
          const newReels = [...prevReels];
          newReels[2] = question.combination[2];
          return newReels;
        });
        clearInterval(newIntervals[2]);
        setStoppingPhase(prev => {
          const newPhase = [...prev];
          newPhase[2] = true;
          setSpinning(false);
          return newPhase;
        });
        setTimeout(() => {
          setFinished(true)
          setAnimation(true)
          updateAppState({ finished: true, initModal: false, currentOptionsShowing:  question.combination});
          // nextQuestion()
        }, 1200);
        setCurrentState('end');
      }, 3500); // Stop third reel after another 1 second
    }else{
      // setCorrectCombination(getRandomCombination())
    }
  }, [spinning]);

  const [currentState, setCurrentState] = useState('start');

  const handleAnimation = () => {
     if (spinning) return
      setCurrentState('animating');
      setTimeout(() => {
        setCurrentState('end');
        setSpinning(true);
        setStoppingPhase([false, false, false]); // Reset stopping phase for each spin
        setReels([getRandomDownturnCause(), getRandomPolicy(), getRandomImplementation()]);
      }, 1700); // 1700 ms for the GIF animation time
    // }
  };

  const getImageSrc = () => {
    switch (currentState) {
      case 'start':
        return LeverStart;
      case 'animating':
        return Lever;
      case 'end':
        return LeverStart;
      default:
        return LeverStart;
    }
  };

const [titleClass, setTitleClass] = useState('fade-in')
const [headingsClass, setHeadingsClass] = useState('fade-in')
const [buttonClass, setButtonClass] = useState('fade-in')
const [onlyTextClass, setOnlyTextClass] = useState('fade-in')
const [spinButtonClass, setSpinButtonClass] = useState('spin-button')

  useEffect(() => {
    if(spinning){
      setTimeout(() => {
        setTitleClass('animate__animated animate__fadeOutUp animate__slow')
        setHeadingsClass('animate__animated animate__fadeInUp animate__slow')
        setSpinButtonClass('spin-button animate__animated animate__fadeOutUp animate__slow')
      }, 4200);
      setTimeout(() => {
        setOnlyTextClass('animate__animated animate__fadeInUp animate__slow')
        setButtonClass('animate__animated animate__fadeInUp animate__slow')
      }, 4700);
    }
  }, [spinning])

  const confettiAnimation = () => {
    console.log("finished", finished)
    return(<Confetti
      width={width}
      height={height}
      run={animation}
      recycle={false}
      // style={{ display: finished ? "block" : 'none' }}
      numberOfPieces={800}
      wind={0.01}
      gravity={0.2}
      // opacity={0}
    />)
  }

  return (
    <>
    {animation && [3, 6, 16].includes(question.index) && confettiAnimation() }
    <div className='slot-machine-container'>
      <div className='inner-container'>
        <div className='machine-grid'>
          {
            finished ?
            <div className={`${headingsClass} header-container`}>
              <h2 className='header-text'>Downturn Cause</h2>
              <img src={Arrow} className='arrows' alt='' />
              <h2 className='header-text'>Policy</h2>
              <img src={Arrow} className='arrows' alt='' />
              <h2 className='header-text'>Implementation</h2>
            </div>
            :
            <div className={`title ${titleClass}`} >
              <img src={Title3} className='title-img' />
            </div>
          }
          <div className='col-container'>
            <div className='col-inner-container'>
              <SlotColumn currentValue={reels[0]} stoped={stoppingPhase[0]} spinning={spinning} />
              <SlotColumn currentValue={reels[1]} stoped={stoppingPhase[1]} spinning={spinning} />
              <SlotColumn currentValue={reels[2]} stoped={stoppingPhase[2]} spinning={spinning} />
            </div>
          </div>
        </div>
        <div className='handle-container'>
          <img
            src={getImageSrc()}
            alt="Click to animate"
            onClick={handleAnimation}
            className='handle-icon'
            style={{ cursor: spinning ? 'not-allowed' : 'pointer' }}
          />
        </div>
      </div>

      <div className='button-container'>
      {finished ?
          <div style={{  display: 'flex' }} className={buttonClass}>
            <div className={`${onlyTextClass} description-container`}>
              <Typography className='description-text' dangerouslySetInnerHTML={{ __html: question.description}}/>
            </div>
            <button className="spin-button spin-button-height" onClick={ questionIndex === 20 ? restartGame : startSpinByButton} disabled={spinning}>{ questionIndex === 20 ? `RESTART` : `SPIN AGAIN` }</button>
          </div>
          :
          <button className={`${spinButtonClass} button-spin`} onClick={startSpinByButton} disabled={spinning}>SPIN</button>
        }
      </div>
      <div className='extra-div' />
      <div className='extra-div' />
    </div>
    </>
  );
};

export default SlotMachine;
